var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_844_3437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12H13.3333V16H2.66667V12H4V13.3333H12V12ZM15.928 8.82933C15.9693 8.992 16 9.15867 16 9.33333C16 9.59598 15.9483 9.85605 15.8478 10.0987C15.7473 10.3414 15.5999 10.5618 15.4142 10.7475C15.2285 10.9333 15.008 11.0806 14.7654 11.1811C14.5227 11.2816 14.2626 11.3333 14 11.3333C13.7374 11.3333 13.4773 11.2816 13.2346 11.1811C12.992 11.0806 12.7715 10.9333 12.5858 10.7475C12.4001 10.5618 12.2528 10.3414 12.1522 10.0987C12.0517 9.85605 12 9.59598 12 9.33333C12 9.86377 11.7893 10.3725 11.4142 10.7475C11.0391 11.1226 10.5304 11.3333 10 11.3333C9.46957 11.3333 8.96086 11.1226 8.58579 10.7475C8.21071 10.3725 8 9.86377 8 9.33333C8 9.86377 7.78929 10.3725 7.41421 10.7475C7.03914 11.1226 6.53043 11.3333 6 11.3333C5.46957 11.3333 4.96086 11.1226 4.58579 10.7475C4.21071 10.3725 4 9.86377 4 9.33333C4 9.59598 3.94827 9.85605 3.84776 10.0987C3.74725 10.3414 3.59993 10.5618 3.41421 10.7475C3.2285 10.9333 3.00802 11.0806 2.76537 11.1811C2.52272 11.2816 2.26264 11.3333 2 11.3333C1.73736 11.3333 1.47728 11.2816 1.23463 11.1811C0.991982 11.0806 0.771504 10.9333 0.585787 10.7475C0.400069 10.5618 0.25275 10.3414 0.152241 10.0987C0.0517317 9.85605 -3.9137e-09 9.59598 0 9.33333C0 9.15867 0.0293333 8.992 0.0706666 8.82933L1.33333 0H14.6667L15.928 8.82933Z",
    fill: "#214ba5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_844_3437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.0625f441c455e2e586f4aa33b636654b.svg";
export { ForwardRef as ReactComponent };